//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/SelectTaggedObjectList.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[1,"SelectedPart",0,"SelectTaggedObjectList",0]],[[["startPointId","endPointId","alignStartPoint","alignEndPoint","length","angle","alignVector","screwSeatInstance","target"],"FinalizePlacementForScrewSeat",{},9,0],[[],"GetScrewSeatLength",{R_:{lengthExp:"Expression"}},0,0],[[],"GetScrewSeatAngle",{R_:{angleExp:"Expression"}},0,0]],[]];
SPLM.Routing.EditPlacePartBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.EditPlacePartBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;